<template>
	<div>
		<div class="title-pic">
			<img class="mainPic" alt="Vue logo" src="../assets/haibao.jpg">
		</div>
		<van-cell-group>
			<van-cell class="list-item" v-if="hasPermission('cust:temp:person_report')" title='材料上传' is-link @click="navTo('/commitment')" />
			<van-cell class="list-item" v-if="hasPermission('cust:temp:person_report')" title='个人体温上报' is-link @click="navTo('/peopleTemp')" />
            <van-cell class="list-item" v-if="hasPermission('cust:temp:school_report')" title='班级体温上报' is-link @click="navTo('/classDaily', 'classTemp')" />
            <van-cell class="list-item" v-if="hasPermission('cust:temp:temperature_gun')" title='刷卡测温' is-link @click="navTo('/tempGun')" />
			<van-cell class="list-item" v-if="hasPermission('cust:temp:school_report')" title='体温补录' is-link @click="navTo('/searchStuMsg')" />
			<van-cell class="list-item" v-if="hasPermission('cust:temp:school_report')" title='宿舍体温填报' is-link @click="navTo('/dormitoryTemp')" />
			<van-cell class="list-item" v-if="hasPermission('cust:temp:person_report')" title='上报历史' is-link @click="navTo('/historyPage')" />
			<van-cell class="list-item" v-if="hasPermission('cust:temp:school_report')" title='体温档案' is-link @click="navTo('/searchStuMsg', 1)" />
		</van-cell-group>
		<p class="list-title gray-background" v-if="hasPermission('cust:temp:manager')">管理</p>
		<van-cell-group>
			<van-cell class="list-item" v-if="hasPermission()" title='消杀记录上报' is-link @click="navTo('/killRecord')" />
			<van-cell class="list-item" v-if="hasPermission('cust:temp:manager')" title='疫情上报推送' is-link @click="navTo('/virusRecord')" />
		</van-cell-group>
		<p class="list-title gray-background" v-if="hasPermission('cust:temp:report_area') || hasPermission('cust:temp:report_school')">数据</p>
		<van-cell-group>
			<van-cell class="list-item" v-if="hasPermission('cust:temp:report_area')" title='辖区学生健康日报' is-link @click="navTo('/manorStuDaily')" />
			<van-cell class="list-item" v-if="hasPermission('cust:temp:report_area')" title='辖区教职工健康日报' is-link @click="navTo('/manorTchDaily')" />
			<van-cell class="list-item" v-if="hasPermission('cust:temp:report_school')" title='学校教职工健康日报' is-link @click="navTo('/schTchDaily')" />
			<van-cell class="list-item" v-if="hasPermission('cust:temp:report_school')" title='学校学生健康日报' is-link @click="navTo('/schStuDaily')" />
			<van-cell class="list-item" v-if="hasPermission('cust:temp:report_class')" title='班级健康日报' is-link @click="navTo('/classDaily')" />
			<van-cell class="list-item" v-if="hasPermission()" title='消杀日报' is-link @click="navTo('/killDaily')" />
		</van-cell-group>
	</div>

</template>

<script>
	import Vue from 'vue';
	import commonObj from '../common/common.js'
	import api from '../http/api.js'
	import {
		Cell,
		CellGroup,
		Toast
	} from 'vant';

	Vue.use(Cell);
	Vue.use(CellGroup)
	Vue.use(Toast)

	export default {
		name: 'Home',
		data() {
			return {
				classList: [],
				uid: window.localStorage.getItem('uid'),
				permsList: [],
				schoolId: window.localStorage.getItem('scId'),
			};
		},
		methods: {
			pageInit() {
				// 获取url传过来的信息
				let window_url_list = window.location.href.split('?')[1].split('&')
				if (window_url_list && window_url_list.length > 0) {
					window_url_list.forEach((item) => {
						let key = item.split('=')[0]
						let value = item.split('=')[1]
						window.localStorage.setItem(key, value)
						if(key == 'api'){
							commonObj.BASEURL = value
						}
					})

                    this.uid = window.localStorage.getItem('uid')
                    this.schoolId = window.localStorage.getItem('scId')
				}
				// 获取角色权限
				let token_ = window.localStorage.getItem('token').replace(/%20/, " ")
				api.getPermsList(token_).then(res => {
					console.log(res)
					if (res.data.code == 200) {
						for (let i = 0; i < res.data.data.length; i++) {
							this.permsList.push(res.data.data[i])
						}
						window.localStorage.setItem('permsList', JSON.stringify(this.permsList));
					}
				})
				api.getUserInfo(this.uid).then(res => {
					if (res.data.code == 200) {
						for (let i = 0; i < res.data.data.roles.length; i++) {
							if (res.data.data.roles[i].id == 6) {
								// 当前用户有教职工的角色
								this.getClessList();
								return;
							}
						}
					} else {
						Toast('获取当前用户信息失败' + res.data.msg)
					}
				})
				// 获取当前学校的正常体温区间
				let key = 'school_' + this.schoolId + '_temperaterRange'
				api.getNormalTempArr(key).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						function insertStr(soure, start, newStr) {
							return soure.slice(0, start) + newStr + soure.slice(start);
						}
						let normalTempArr = res.data.data.configValue.split(',')
						let min_temp = insertStr(normalTempArr[0], 2, '.')
						let max_temp = insertStr(normalTempArr[1], 2, '.')
						window.localStorage.setItem('minTemp', min_temp)
						window.localStorage.setItem('maxTemp', max_temp)

					} else {
						Toast('获取体温区间失败' + res.data.msg)
					}


				})
			},
			getClessList() {
				api.getClassList(this.uid).then(res => {
					if (res.data.code == 200) {
						for (let i = 0; i < res.data.data.length; i++) {
							this.classList.push(res.data.data[i])
						}
					} else {
						Toast('获取班级列表失败：' + res.data.msg)
					}
				})
			},
			navTo(url, t) {
				if (url == '/classDaily' && t == 'classTemp') {
					if (this.classList.length > 1) {
                        this.$router.push({
                            path: '/selectClass',
                            query: {
                                isClassTemp: true
                            }
                        })
					} else if (this.classList.length == 1) {
						console.log(this.classList[0].id);
						this.$router.push({
							path: url,
							query: {
								id: this.classList[0].id,
                                isClassTemp: true
							}
						})
					} else {
						Toast("没有对应的班级")
					}
				} else if (url == '/searchStuMsg' && t) {
					this.$router.push({
						path: url,
						query: {
							isArchives: 1
						}
					})
				} else if (url == '/classDaily') {
					if (this.classList.length > 1) {
						this.$router.push({
							path: '/selectClass',
							query: {
								type: 1
							}
						})
					} else if (this.classList.length == 1) {
						console.log(this.classList[0].id);
						this.$router.push({
							path: url,
							query: {
								id: this.classList[0].id
							}
						})
					} else {
						Toast("没有对应的班级")
					}
				} else {
					this.$router.push(url)
				}
			},
			hasPermission(temp) {
				console.log(commonObj.hasPermission(temp, this.permsList))
				return commonObj.hasPermission(temp, this.permsList)
			}
		},
		mounted() {
			this.pageInit()
		}
	}
</script>

<style scoped>
	.title-pic {
		padding: 10px;
		text-align: center;
	}

	.list-item {
		text-align: left;
	}

	.list-title {
		text-align: left;
		padding-left: 16px;
		margin: 0;
		line-height: 40px;
	}

	.mainPic {
		max-width: 100%;
		height: 200px;
	}
</style>
